import React, { createContext, useContext, useEffect, useState } from 'react';
import { Button, Container, Heading } from '@chakra-ui/react';
import axios from 'axios';
import { Outlet, useNavigate } from 'react-router-dom';

const AdminContext = createContext(null);

export function useAdmin() {
  return useContext(AdminContext);
}

export default function AdminGuard() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    axios
      .get('/api/auth/me')
      .then((r) => {
        if (r.data.ok) setUser(r.data.user);
        else setUser(null);
      })
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const onLogin = () => {
    window.location.href = '/api/auth/start';
  };

  const signOut = async () => {
    try {
      await axios.post('/api/auth/signout');
    } catch (e) { }
    setUser(null);
    nav('/admin');
  };

  if (loading) return <Container p={4}><Heading>Loading…</Heading></Container>;

  if (!user)
    return (
      <Container p={4}>
        <Heading mb={4}>Admin</Heading>
        <Button onClick={onLogin} mb={4}>Sign in with GitHub</Button>
        <Button as="a" href="/qr-codes" colorScheme="teal" variant="outline" w="100%">View QR Codes</Button>
      </Container>
    );

  return (
    <AdminContext.Provider value={{ user, signOut }}>
      <Outlet />
    </AdminContext.Provider>
  );
}
